(function () {
  'use strict';

  angular.module('wsLrs.cards').factory("GroupUtils", ["$q", "ChartBuilder", "Groups", "$location", "wsConstants", "$routeParams", function ($q, ChartBuilder, Groups, $location, wsConstants, $routeParams) {
    return {
      getGroup: function getGroup(id) {
        return Groups.get(id, {
          params: {
            sparse: false
          }
        });
      },
      getGroupCount: function getGroupCount(isDemo) {
        return Groups.count({
          params: {
            demo: isDemo
          }
        });
      },
      getRootGroups: function getRootGroups(cfg) {
        cfg = cfg || {};
        if (typeof cfg.sparse === 'undefined') {
          cfg.sparse = true;
        }
        if (typeof cfg.rootOnly === 'undefined') {
          cfg.rootOnly = true;
        }
        return Groups.get("", {
          params: {
            sparse: cfg.sparse,
            rootOnly: cfg.rootOnly,
            onlyRootsUnder: cfg.onlyRootsUnder,
            "type.name": cfg["type.name"]
          }
        }).then(function (response) {
          return response.results;
        },
        //On failure, return nothing
        function () {
          return null;
        });
      },
      getGroupAndImmediateChildren: function getGroupAndImmediateChildren(rootGroup) {
        return Groups.get("", {
          params: {
            childDepth: 1
          }
        }).then(function (response) {
          var allGroups = response.results;
          if (!allGroups) {
            return [rootGroup];
          }
          var childIds = rootGroup.childGroupIds;
          var childGroups = _.filter(allGroups, function (group) {
            return _.contains(childIds, group.id);
          });
          return [rootGroup].concat(_(childGroups).sortBy("name"));
        },
        //On failure, return the root
        function () {
          return [rootGroup];
        });
      },
      getGroups: function getGroups(ids, cfg) {
        return Groups.multiGet(ids, cfg).then(function (response) {
          return response.results;
        },
        //On failure, return error
        function error(response) {
          return response.status === 404 ? null : $q.reject(response);
        });
      },
      createGroupUrl: function createGroupUrl(url) {
        if ($routeParams.groupId) {
          return url.slice(0, url.lastIndexOf("/"));
        }
        return url;
      },
      startGroups: function startGroups(createDetailsPage, groupInfo, filter) {
        //properties of groupInfo that will be set:
        //showGroups - boolean that determines if group visualizations should be shown
        //selectedGroup - only set if exactly 1 group was selected (and no people)
        //showGroupLink - boolean that determines if group drill-down links should be shown.
        //               is true only if 1 group selected or allView
        //selectedGroupName - only set if exactly 1 group was selected (and no people)
        //groupIds - the groupIds that are included / should be displayed

        //initializing these values
        groupInfo.selectedGroupName = null;
        groupInfo.companyName = "";
        var self = this,
          filteredGroupIds = filter && filter.groupIds ? filter.groupIds : [],
          filteredGroupTypes = filter && filter.groupTypeNames ? filter.groupTypeNames : [],
          filteredCustomGroupIds = filter && filter.groupCustomIds ? filter.groupCustomIds : [],
          hasPeopleFilter = filter && filter.personIds && filter.personIds.length > 0;
        this.getGroupCount().then(function (groupCount) {
          if (groupCount === 0) {
            groupInfo.showGroups = false;
            createDetailsPage(null, true);
            return;
          }

          //only show groups if card not also filtered by people
          groupInfo.showGroups = !hasPeopleFilter;

          //if 1 group selected (and not also filtered by people) show the group and it's children
          if ($routeParams.groupId || filteredGroupIds.length === 1 && !hasPeopleFilter) {
            var groupId = $routeParams.groupId || filteredGroupIds[0];
            self.getGroup(parseInt(groupId)).then(function (response) {
              groupInfo.selectedGroup = response;
              createDetailsByGroup(groupInfo.selectedGroup);
            }, function () {
              groupInfo.showGroups = false;
              createDetailsPage(null, true);
            });
          } else if (filteredGroupIds.length >= 1 || filteredCustomGroupIds.length >= 1) {
            createDetailsByGroups(filteredGroupIds, filteredCustomGroupIds);
          } else if (hasPeopleFilter) {
            //filtered by people only, so set noGroupFilter to true
            createDetailsPage(null, true);
          } else {
            //Otherwise, go ahead with creating the page.
            createAllPage({
              "type.name": filteredGroupTypes
            });
          }
        });
        function createAllPage(cfg) {
          self.getRootGroups(cfg).then(function (response) {
            setGroupData(response, true);
          });
        }
        function createDetailsByGroup(group) {
          self.getGroupAndImmediateChildren(group).then(setGroupData);
        }
        function createDetailsByGroups(groups, customIds) {
          // send customIds as well here
          var cfg = {
            params: {
              customIds: customIds
            }
          };
          self.getGroups(groups, cfg).then(function (response) {
            setGroupData(response, false);
          });
        }
        function setGroupData(groups, noGroupFilter) {
          groupInfo.groupIds = filteredGroupIds;
          groupInfo.selectedGroupName = null;
          groupInfo.companyName = "";
          if (groupInfo.selectedGroup) {
            groupInfo.selectedGroupName = groupInfo.selectedGroup.name;
            groupInfo.companyName = groupInfo.selectedGroup.name + " ";
          }

          //only show links to drill into group if not filtered by group,
          // or 1 group selected and no people selected
          if (groupInfo.selectedGroup || noGroupFilter) {
            groupInfo.showGroupLink = true;
          }
          createDetailsPage(groups, noGroupFilter);
        }
      },
      isGroup: function isGroup(personOrGroupOrGroupType) {
        return !_.isUndefined(personOrGroupOrGroupType.childGroupIds);
      },
      isGroupType: function isGroupType(personOrGroupOrGroupType) {
        var hasNoPersonas = !personOrGroupOrGroupType.personas;
        var hasNoPeople = !personOrGroupOrGroupType.peopleIds;
        return hasNoPersonas && hasNoPeople;
      }
    };
  }]);
})();
